import {
  Button,
  Dialog,
  Backdrop,
  DialogTitle,
  DialogActions,
  DialogContent,
  CircularProgress,
  DialogContentText,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { BaseResponse } from 'library/types';
import { FormattedMessage } from 'react-intl';
import loaderLogoSrc from 'assets/images/idecon-loader-logo.png';
import { Dispatch, ReactNode, SetStateAction, useState } from 'react';
import { GridRowId, GridRowSelectionModel } from '@mui/x-data-grid-premium';

type DeleteDialogProps = {
  open: boolean;
  id: GridRowId;
  handleClose: () => void;
  refresh: () => Promise<void>;
  setRowSelectionModel: Dispatch<SetStateAction<GridRowSelectionModel>>;
  title: ReactNode;
  subTitle: ReactNode;
  action: (id: number) => Promise<BaseResponse<{}>>;
  successMessage: ReactNode;
};

const DeleteDialog = ({
  open,
  id,
  handleClose,
  refresh,
  setRowSelectionModel,
  title,
  subTitle,
  action,
  successMessage,
}: DeleteDialogProps) => {
  // other hooks
  const { enqueueSnackbar } = useSnackbar();

  // useState hooks
  const [loading, setLoading] = useState(false);

  // async helper functions
  const handleDelete = async () => {
    try {
      setLoading(true);

      const response = await action(Number(id));

      if (response.isSuccess) {
        enqueueSnackbar(successMessage, { variant: 'success' });
        handleClose();
        setRowSelectionModel([]);
        refresh();
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
        <DialogContentText>{subTitle}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button onClick={handleClose}>
          <FormattedMessage id="forgotPassword.cancel" defaultMessage="Vazgeç" />
        </Button>
        <Button variant="contained" type="button" onClick={handleDelete}>
          <FormattedMessage id="forgotPassword.continue" defaultMessage="Devam" />
        </Button>
      </DialogActions>
      <Backdrop
        sx={{ display: 'flex', flexDirection: 'column', color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}>
        <img src={loaderLogoSrc} alt="loader-logo" />
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
};

export default DeleteDialog;
